import { Text, HStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

interface OfferSummaryProps {
  item: {
    label: string;
    value: string | number;
  };
}

export const OfferSummary: React.FC<OfferSummaryProps> = ({ item }) => {
  return (
    <HStack flex={1} justifyContent="space-between">
      <Text fontSize={Typography['fontsize.xs']} variant="regular" color="neutral.dark">
        {item.label}
      </Text>
      <Text fontSize={Typography['fontsize.xs']} variant="regular" color="neutral.black">
        {item.value}
      </Text>
    </HStack>
  );
};
